import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import Header from "../../component/Header";
import Pagination from "../../component/Pagination";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import IconDate from "../../component/SvgIcons/IconDate";
import IconFilter from "../../component/SvgIcons/IconFilter";
import IconSearchTable from "../../component/SvgIcons/IconSearchTable";
import DateFilter from "../../component/DateFilter/DateFilter";
import api from "../../services/axios";
import useBootstrapTooltip from "../../services/useBootstrapTooltip";
import AudioPlayer from "../TicketsDetails/AudioPlayer";
import { useAuth } from "../../context/AuthContext";
import { AnimatePresence, motion, } from "framer-motion";
import CustomDropdown from "../../component/CustomDropdown";
import numberOptions from "../../component/NumberOptions/numberOptionsdata";

export default function UserLogs() {
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredCalls, setFilteredCalls] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [itemsPerPage, setItemsPerPage] = useState(
    window.innerWidth >= 1920 ? 16 : 10
  );


  useEffect(() => {
    let response = rowData.filter((row) => {
      if (!row || typeof row !== 'object') return false;
      return Object.values(row).some((value) => {
        if (value == null) return false;
        return value.toString().toLowerCase().includes(searchQuery.toLowerCase());
      });
    })
      .sort((a, b) => {
        if (!sortConfig.key) return 0;
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];
        if (aValue === undefined || bValue === undefined) return 0;
        const isNumber = !isNaN(aValue) && !isNaN(bValue);
        return isNumber
          ? (sortConfig.direction === 'asc' ? Number(aValue) - Number(bValue) : Number(bValue) - Number(aValue))
          : (sortConfig.direction === 'asc'
            ? String(aValue).localeCompare(String(bValue))
            : String(bValue).localeCompare(String(aValue)));
      });

    setFilteredCalls(response);
  }, [searchQuery, sortConfig, rowData])
  const paginatedData = filteredCalls.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const { authUser } = useAuth();

  const handleSort = (column) => {
    setSortConfig((prevConfig) => {
      if (prevConfig.key === column) {
        return {
          ...prevConfig,
          direction: prevConfig.direction === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          key: column,
          direction: "asc",
        };
      }
    });
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    const fetchUserLogs = async () => {
      setIsLoading(true);
      try {
        let payload = {};
        payload = {
          filterOptions: Object.keys(filters)?.length ? filters : { direction: 'inbound' }
        }
        const res = await api.post("/GetUserLogs", payload);

        if (res.data.userLogs && Array.isArray(res.data.userLogs)) {
          setRowData(res.data.userLogs);
          setFilteredCalls(res.data.userLogs);
        } else {
          setRowData([]);
          setFilteredCalls([]);
          console.warn("Unexpected data format:", res.data.userLogs);
        }
      } catch (error) {
        console.error("Failed to fetch tickets:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserLogs();
  }, []);

  const handlePeriodSelect = (filterObj) => {
    console.log(filterObj)
    // setFilterDates([startDate, endDate]);
    setFilters(filterObj)
  };


  const totalPages = Math.ceil(rowData.length / itemsPerPage);
  // ✅ Initialize Bootstrap tooltips
  useBootstrapTooltip([paginatedData, currentPage]);
  // ✅ Handle page change
  const handlePageChange = (page) => {
    console.log("Page clicked:", page);
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <div className="dashboard">
      <Header title subtitle="User Logs" searchbar />
      <div className="center-content">
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <AnimatePresence mode="wait">
              <motion.div
                className="pagegap d-flex flex-column"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.4 }}
              >
                <h2 className="create-titles mb-0 d-flex align-items-center">
                  <DiamondsFour /> <span>Call Records</span>
                </h2>
                <div className="tabletopbar d-flex align-items-center gap-2 justify-content-between flex-column flex-md-row">
                  <div className="d-flex align-items-center gap-3 justify-center" style={{ justifyContent: 'space-between', width: '100%', alignContent: 'center' }}>
                    <DateFilter showDateFilter={true} onPeriodSelect={handlePeriodSelect} />
                    <div style={{ display: 'flex' }}>
                      <div className="tablesearch position-relative">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Search"
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                        <span className="position-absolute">
                          <IconSearchTable />
                        </span>
                      </div>

                      <CustomDropdown
                        name="itemsPerPage"
                        options={numberOptions}
                        value={itemsPerPage.toString()}
                        onChange={(value) => {
                          const num = Number(value);
                          setItemsPerPage(num);
                          setCurrentPage(1);
                        }}
                        placeholder="Items Per Page"
                        className="items-per-page-dropdown"
                      />
                    </div>
                  </div>
                </div>
                <div className="tablespace">
                  <div className="table-responsive">
                    <table className="table table-hover my-0">
                      <thead className="thead-light">
                        <tr>
                          <th width="50" style={{ paddingRight: "5px" }}>
                            Sr. No
                          </th>
                          <th width="100">
                            <div className="d-flex align-items-center justify-content-between">
                              Agent Name
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("agent_name")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="100">
                            <div className="d-flex align-items-center justify-content-between">
                              Login Status
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("user_status")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="100">
                            <div className="d-flex align-items-center justify-content-between">
                              Created At
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("created_at")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="100">
                            <div className="d-flex align-items-center justify-content-between">
                              Last HeartBeatss
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("last_heartbeat")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <td colSpan="10" className="text-center" style={{ padding: "30px" }}>
                              Loading User Logs, please wait...
                            </td>
                          </tr>
                        ) : paginatedData?.length > 0 ? (
                          paginatedData?.map((latestItem, mainIndex) => {
                            const mainSerial = (currentPage - 1) * itemsPerPage + mainIndex + 1;
                            return (
                              <Fragment key={mainIndex}>
                                {/* Render the latest ticket row */}
                                <tr
                                  key={latestItem?.Call_Sr_No}
                                  className={[
                                    selectedRows.includes(latestItem?.Ticket_No) ? "ticket-row selected-row" : "ticket-row"
                                  ].join(" ")}
                                  style={{ cursor: "pointer" }}>
                                  <td>{mainSerial}</td>
                                  <td>
                                    {latestItem?.agent_name || '-'}
                                  </td>
                                  <td>
                                    {latestItem?.user_status}
                                  </td>
                                  <td>
                                    {latestItem?.created_at}
                                  </td>
                                  <td>
                                    {latestItem?.last_heartbeat}
                                  </td>

                                </tr>
                              </Fragment>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">
                              No data found for the selected custom date range.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {totalPages > 1 && (
                    <Pagination
                      totalPages={totalPages}
                      currentPage={currentPage}
                      handlePageChange={handlePageChange}
                    />
                  )}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}
